/**
 * Espelha a lógica de ModuleGuard e do menu (Layout): módulos do plano
 * cruzados com user.permissoes.modulos para operadores.
 */

/**
 * Se existe `empresa.plano` mas `modulosHabilitados` é inválido ou vazio → `[]` (nenhum módulo).
 * Se não há plano na empresa → `undefined` (comportamento legado: não restringir pelo plano).
 */
export function getPlanoModulosEfetivos(empresa) {
  if (!empresa?.plano) return undefined;
  const raw = empresa.plano.modulosHabilitados;
  if (Array.isArray(raw) && raw.length > 0) return raw;
  return [];
}

/**
 * Lista final de moduleIds para menu / ModuleGuard.
 * @returns {{ basePlanoMods: string[]|undefined, allowedModules: unknown }}
 */
export function resolveAllowedModulesForUser(user, empresa) {
  const basePlanoMods = getPlanoModulosEfetivos(empresa);
  let allowedModules = basePlanoMods === undefined ? empresa?.plano?.modulosHabilitados : basePlanoMods;

  if (user.role === "operador" && Array.isArray(user.permissoes?.modulos)) {
    const userModulos = user.permissoes.modulos;
    if (basePlanoMods === undefined) {
      allowedModules =
        Array.isArray(empresa?.plano?.modulosHabilitados) && empresa.plano.modulosHabilitados.length > 0
          ? empresa.plano.modulosHabilitados.filter((m) => userModulos.includes(m))
          : userModulos;
    } else {
      allowedModules = basePlanoMods.length > 0 ? basePlanoMods.filter((m) => userModulos.includes(m)) : [];
    }
  }

  return { basePlanoMods, allowedModules };
}

export function userHasModuleAccess(user, empresa, moduleId) {
  if (!moduleId || !user) {
    return true;
  }

  const { basePlanoMods, allowedModules } = resolveAllowedModulesForUser(user, empresa);

  if (basePlanoMods !== undefined) {
    if (Array.isArray(allowedModules) && allowedModules.length > 0) {
      if (allowedModules.includes(moduleId)) return true;
      if (moduleId === "AtestadosDeclaracoes" && allowedModules.includes("Documentos")) return true;
      if (moduleId === "Documentos" && allowedModules.includes("AtestadosDeclaracoes")) return true;
      return false;
    }
    return false;
  }

  if (user.role === "operador" && Array.isArray(allowedModules) && allowedModules.length === 0) {
    return false;
  }

  if (Array.isArray(allowedModules) && allowedModules.length > 0) {
    if (allowedModules.includes(moduleId)) return true;
    if (moduleId === "AtestadosDeclaracoes" && allowedModules.includes("Documentos")) return true;
    if (moduleId === "Documentos" && allowedModules.includes("AtestadosDeclaracoes")) return true;
    return false;
  }
  return true;
}
